import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {CreatePortConnectionComponent} from '@catmodules/models/feature-port/components/create-port-connection/create-port-connection.component';
import {FeaturePortFormComponent} from '@catmodules/models/feature-port/components/feature-port-form/feature-port-form.component';
import {ModifyPortConnectionComponent} from '@catmodules/models/feature-port/components/modify-port-connection/modify-port-connection.component';
import {FeaturePortConnectionService} from '@catmodules/models/feature-port/services/feature-port-connection.service';
import {FeaturePortService} from '@catmodules/models/feature-port/services/feature-port.service';
import {PortModule} from '@catmodules/models/ports/port.module';
import {SlideInModalModule} from '@catmodules/widgets/slide-in-modal/slide-in-modal.module';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';

const publicComponents = [
  FeaturePortFormComponent,
  CreatePortConnectionComponent,
  ModifyPortConnectionComponent,

];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIBaseModule,
  UIFormModule,
  SlideInModalModule,
  PortModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [FeaturePortConnectionService, FeaturePortService];
const entryComponents = [
  ...publicComponents,
];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class FeaturePortModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/feature-port/feature-port.module.ts